// ---------------------------------------------------------------------------
// Shared types for the AI-Guide module.
//
// One editable document per category, per institute — not a list of many
// entries. CATEGORY_LIMITS mirrors helpers/AIGuide/AIGuide.schemas.js on the
// backend (Functions3/functions) — keep the two in sync if either changes.
// Word limits bound how much gets injected into the AI prompt per query.
// ---------------------------------------------------------------------------

export type AIGuideCategory = "news_updates" | "general";

export type CategoryLimits = {
  label: string;
  maxWords: number;
  maxChars: number;
};

export const CATEGORY_LIMITS: Record<AIGuideCategory, CategoryLimits> = {
  news_updates: {
    label: "News & Updates",
    maxWords: 400,
    maxChars: 400 * 7,
  },
  general: {
    label: "General Information",
    maxWords: 900,
    maxChars: 900 * 7,
  },
};

export function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export type AIGuideDocument = {
  category: AIGuideCategory;
  content: string;
  isActive: boolean;
  updatedBy: string | null;
  createdAt: number | null;
  updatedAt: number | null;
};
